export default __webpack_public_path__ + "static/media/chatton12.921a4698.jpg";